// tslint:disable
export enum TransmissionType {
    /**
     * @description INBOUND
     */
    INB = 1,
    /**
     * @description OUTBOUND
     */
    OUTB = 2,
}
